import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import { Contract } from '../store';
import * as fromAccount from '../../store';
import { AccountContract } from '../../store/account-contract.model';
import { SelectItem } from '../../../shared/efaact-primeng.module';
import { IStatusMessage } from '../../../shared';
import { IShowErrors } from '../../../shared/errors-sidenav';

@Component({
    selector: 'ef-accounts-receivable-contract-container',
    templateUrl: './accounts-receivable-contract-container.component.html',
    styleUrls: ['./accounts-receivable-contract-container.component.scss'],
    standalone: false
})
export class AccountsReceivableContractContainerComponent implements OnInit {
    @Input() public set accounts(value: fromAccount.Account[]) {
        if (value) {
            this.accountItems = value.map(x => ({
                label: x.AccountCode,
                value: x.AccountListID
            }));
        }
    }
    @Input() selectedError: IStatusMessage;
    accountItems: SelectItem[];
    @Input() contracts: AccountContract[];
    @Output() public ShowError = new EventEmitter<IShowErrors>();
    constructor(private store: Store<any>) {}

    ngOnInit() {}
    onSaveAccountContract($event: AccountContract[]) {
        this.store.dispatch(
            fromAccount.putContractARAccounts({ contracts: $event })
        );
    }
}
